<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{ modalTitle | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>


        <form [formGroup]="feesForm" class="p-2 mt-n2 form">
            <div class="row">
                <div class="col-md-12">
                    <div class="mb-2">

                        <label for="field-3" class="form-label">
                            {{ 'SETTINGS.FEES.FORM.FEE' | translate }} <span class="text-error">*</span>
                        </label>
                        <input type="text" class="form-control" id="field-3" formControlName="name"
                            [ngClass]="{'is-invalid':submitted && formFee.name.invalid}" required>

                        <div *ngIf="submitted && formFee.name.invalid" class="invalid-feedback">
                            <div *ngIf="formFee.name.errors?.required" i18n>
                                {{ 'SETTINGS.FEES.FORM.FEEREQUIRED' | translate }}
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-12">
                    <div class="mb-2">

                        <label class="form-label">
                            {{ 'SETTINGS.FEES.FORM.COUNTRY' | translate }}
                        </label>
                        <ngx-select formControlName="country" appendTo="body" [items]="countries" (select)="setCountryName()"
                            [placeholder]="'REGISTER.COMPANY.SELECT_COUNTRY' | translate">
                        </ngx-select>
                    </div>

                </div>
                <div class="col-md-12">
                    <div class="mb-2">

                        <label class="form-label">
                            {{ 'SETTINGS.FEES.FORM.VALUE' |
                            translate }}<span class="text-error">*</span></label>
                        <input type="number" (keypress)="utilSrv.validatePositiveDecimalNumbers($event)"
                            class="form-control" formControlName="value" [readOnly]="loading" step="0.01" min="0"
                            [ngClass]="{'is-invalid':submitted && formFee.value.invalid}" required>
                            <div *ngIf="submitted && formFee.value.invalid" class="invalid-feedback">
                                <div *ngIf="formFee.value.errors?.required" i18n>
                                    {{ 'SETTINGS.FEES.FORM.VALUEREQUIRED' | translate }}
                                </div>
                            </div>

                    </div>

                </div>
            </div>
        </form>
    </div>
    <div class="mt-1 mb-2 d-flex justify-content-center">
        <button *ngIf="!id" type="button" class="btn btn-primary btn-action btnSaveBottom mt-1 btnSaveMinW2"
            (click)="save()">

            {{'SETTINGS.FEES.ADD' | translate }}
        </button>
        <button *ngIf="id" type="button" class="btn btn-primary btn-action btnSaveBottom mt-1 btnSaveMinW2"
            (click)="save()">

            {{'SETTINGS.FEES.EDIT' | translate }}
        </button>
    </div>
</ng-template>